import { moveElementToContainer } from "../utils/functions";

const pageProductTab = () => {
  if (document.querySelector("body.product-page")) {
    setTimeout(() => {
      // Give Classes to Tabs
      const tabs = document.querySelectorAll(".product-detail__item");
      giveClassesToTabs(tabs);

      // Move Scheda Tecnica Tab under Gallery
      const schedaTecnica = document.querySelector(".schedatecnica"),
        dataSheet = document.querySelector(".datasheet"),
        technicalsheet = document.querySelector(".technicalsheet"),
        brochure = document.querySelector(".brochure"),
        container = document.querySelector(".product-hero__image");
      if (schedaTecnica) {
        moveElementToContainer(schedaTecnica, container);
      }
      if (dataSheet) {
        moveElementToContainer(dataSheet, container);
      }
      if (technicalsheet) {
        moveElementToContainer(technicalsheet, container);
      }
      if (brochure) {
        moveElementToContainer(brochure, container);
      }

      // Move Confezione Tab under Cart Button
      const confezione = document.querySelector(".confezione"),
        packaging = document.querySelector(".packaging"),
        box = document.querySelector(".box"),
        contentWrap = document.querySelector(".product-hero__content__wrap");
      if (confezione) {
        moveElementToContainer(confezione, contentWrap);
      }
      if (packaging) {
        moveElementToContainer(packaging, contentWrap);
      }
      if (box) {
        moveElementToContainer(box, contentWrap);
      }

      // Format Premi Tab Title
      const premi = document.querySelector(".ipremi");
      if (premi) {
        formatPremiTitle(premi);
      }
    }, 1000);
  }
};

export default pageProductTab;

/**
 * Give Classes to Tabs
 *
 * @param array tabs
 */

const giveClassesToTabs = (tabs) => {
  if (tabs) {
    tabs.forEach((tab) => {
      const title = tab.querySelector(".product-detail__title"),
        elementClass = title.innerHTML.toLowerCase().replace(/\s/g, "");
      tab.classList.add(elementClass);
    });
  } else {
    console.log("Missing params in function giveClassesToTabs(tabs)", [tabs]);
  }
}

/**
 * Format Premi Tab Title
 *
 * @param html tab
 */

const formatPremiTitle = (tab) => {
  if (tab) {
    const title = tab.querySelector(".product-detail__title");
    title.innerHTML = title.innerHTML.toLowerCase();
  } else {
    console.log("Missing params in function formatPremiTitle(tab)", [tab]);
  }
}
